export default __webpack_public_path__ + "static/media/account-blue.83235f7f.svg";